<template>
  <div>
    <!-- Map -->
    <Map
      :zoom="5"
      :height="85"
      :action="'stationSetupOverview'"
      :markerObjects="markerObjects"
      v-if="showMap === true"
    />
  </div>
</template>

<script setup>
import Map from "@/components/Map.vue";
</script>

<script>
import { mapGetters } from "vuex";

import CordraMixin from "@/mixins/cordra";

export default {
  name: "SensorsSetupsOverview",
  mixins: [CordraMixin],
  data() {
    return {
      showMap: false,
      markerObjects: [],
    };
  },
  methods: {},

  created() {
    this.docType = process.env.VUE_APP_CORDRA_DATATYPE_STATIONSSETUP;

    this.cordraSearch();
  },

  computed: {
    ...mapGetters({
      keycloakGetStatusReady: "keycloak/getStatusReady",
      keycloakGetStatusAuthenticated: "keycloak/getStatusAuthenticated",
    }),
  },

  watch: {
    cordraSearchResult: {
      handler(newValue, oldValue) {
        console.log("watch newValue", newValue);

        if (oldValue.lenght == 0 && newValue.lenght > 0) {
          this.$router.push("/stationsetupsoverview");
        }

        this.showMap = false;

        this.markerObjects = []; // Reset

        for (let obj of newValue) {
          let tempObj = {};

          tempObj.lat = obj.content["decimalLatitude"];
          tempObj.lng = obj.content["decimalLongitude"];
          tempObj.id = obj.id;

          this.markerObjects.push(tempObj);
        }
        this.showMap = true;
      },
      deep: true, // Shallow watcher is't enough
    },
  },
};
</script>

<style></style>
